import dispatcher from "../dispatcher";
import { mpdConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";

export function createMpd(mpd) {
    rq.post("/api/v1/mpds", mpd).then((data) => {
        mpd.mpdId = data[0].lastId;
        dispatcher.dispatch({ type: mpdConstant.MPD_CREATED, mpd });
    }).catch((data) => {
        dispatcher.dispatch({ type: mpdConstant.MPD_CREATION_FAILED, msg: `creating MPD ${mpd.mpdName} failed ! ${data.responseText}` });
    });
}


export function fetchAllMpdsWithProduct() {
    rq.getJsonData("/api/v1/mpdswithproduct").then((data) => {
        dispatcher.dispatch({ type: mpdConstant.MPD_FETCHED_ALL_WITH_PRODUCT, data });
    }).catch((data) => {
        dispatcher.dispatch({ type: mpdConstant.MPD_FETCHED_FAILED, msg: `Fething MPDs failed ! ${data.responseText}` });
    });
}

export function fetchAllMpd() {
    rq.getJsonData("/api/v1/mpds").then((data) => {
        dispatcher.dispatch({ type: mpdConstant.MPD_FETCHED_ALL, data });
    }).catch((data) => {
        dispatcher.dispatch({ type: mpdConstant.MPD_FETCHED_FAILED, msg: `Fething MPDs failed ! ${data.responseText}` });
    });
}


// WEBPACK FOOTER //
// ./src/jsx/actions/mpd-action.jsx